import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import CommandResult from "../../Common/Models/CommandResult";
import CreateFileGroupingFileSpecCommand from "../FileGroupingFileSpecs/Models/Commands/CreateFileGroupingFileSpecCommand";
import UpdateFileGroupingFileSpecCommand from "../FileGroupingFileSpecs/Models/Commands/UpdateFileGroupingFileSpecCommand";
import FileGroupingFileSpecLookup from "../FileGroupingFileSpecs/Models/Lookups/FileGroupingFileSpecLookup";
import FileTypeLookup from "../FileGroupingFileSpecs/Models/Lookups/FileTypeLookup";
import FileGroupingFileSpecSearchCriteria from "../FileGroupingFileSpecs/Models/Queries/FileGroupingFileSpecSearchCriteria";

export interface IFileGroupingFileSpecApiClient {
    addNewFileGroupingFileSpec(command: Model.PlainObject<CreateFileGroupingFileSpecCommand>) : AxiosPromise<Model.PlainObject<CommandResult>>;
    getFileGroupingFileSpecList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<FileGroupingFileSpecSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<FileGroupingFileSpecLookup>>>;
    getFileSpecList(fileGroupingID?: number) : AxiosPromise<Array<Model.PlainObject<FileTypeLookup>>>;
    getFileTypeListByCriteria(criteria: string): AxiosPromise<Array<Model.PlainObject<FileTypeLookup>>>;
    updateFileGroupingFileSpec(command: Model.PlainObject<UpdateFileGroupingFileSpecCommand>) : AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class FileGroupingFileSpecApiClient extends Data.ApiClientBase implements IFileGroupingFileSpecApiClient {
    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/StaticServiceProviderFileGroupingsFileSpec`)
    }

    public addNewFileGroupingFileSpec(command: Model.PlainObject<CreateFileGroupingFileSpecCommand>) : AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/AddNewFileGroupingFileSpec`, command);
    }

    public getFileGroupingFileSpecList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<FileGroupingFileSpecSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<FileGroupingFileSpecLookup>>> {
        return this.axios.get(`${this.apiPath}/GetFileGroupingFileSpecs?${Utils.getQueryString(payload)}`);
    }

    public getFileSpecList(fileGroupingID?: number) : AxiosPromise<Array<Model.PlainObject<FileTypeLookup>>> {
        return this.axios.get(`${this.apiPath}/GetFileSpecList`+ (fileGroupingID !== 0 ? `?SearchCriteria.StaticServiceProviderFileGroupingID=${fileGroupingID}` : ``));
    }

    public getFileTypeListByCriteria(criteria: string): AxiosPromise<Array<Model.PlainObject<FileTypeLookup>>> {
        return this.axios.get(`${this.apiPath}/getFileTypeListByCriteria`, { params: { criteria: criteria } });
    }

    public updateFileGroupingFileSpec(command: Model.PlainObject<UpdateFileGroupingFileSpecCommand>) : AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.patch(`${this.apiPath}/UpdateFileGroupingFileSpec`, command);
    }
}